import { render, staticRenderFns } from "./CampusRecruiting.vue?vue&type=template&id=2bd7fbdc&scoped=true"
import script from "./CampusRecruiting.vue?vue&type=script&lang=js"
export * from "./CampusRecruiting.vue?vue&type=script&lang=js"
import style0 from "./CampusRecruiting.vue?vue&type=style&index=0&id=2bd7fbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7fbdc",
  null
  
)

export default component.exports